import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import { fg } from '@atlaskit/platform-feature-flags';
import TextArea from '@atlaskit/textarea';
export var EditParagraph = function EditParagraph(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label;
  // Local state required to show textarea changes as onChange callback is debounced.
  // Without it, user will only see their last inputted character added within the debounce period.
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    textAreaValue = _useState2[0],
    setTextAreaValue = _useState2[1];
  useEffect(function () {
    setTextAreaValue(value);
  }, [value]);
  var debouncedOnChange = useMemo(function () {
    return onChange ? debounce(onChange, fg('proforma_reduce_debounce_for_csm') ? 250 : 500) : noop;
  }, [onChange]);
  var handleTextAreaChange = useCallback(function (e) {
    e.persist();
    setTextAreaValue(e.target.value);
    debouncedOnChange(e);
  }, [debouncedOnChange]);
  return /*#__PURE__*/React.createElement(TextArea, _extends({
    appearance: "standard",
    isCompact: false,
    isDisabled: false,
    isReadOnly: false,
    isInvalid: isInvalid,
    isRequired: isRequired,
    minimumRows: 5,
    maxHeight: "none",
    isMonospaced: false,
    value: textAreaValue,
    defaultValue: undefined,
    resize: "smart",
    spellCheck: false,
    onBlur: undefined,
    onChange: handleTextAreaChange,
    onFocus: undefined,
    id: id,
    "aria-label": label
  }, isInvalid && errorId && fg('jsm-accessibility-fixes') ? {
    'aria-describedby': errorId
  } : {}));
};